/**
 * 鸿蒙智行主体ID
 *
 * 同时匹配 uat 与 pro 两个环境的ID，不按构建 mode 区分；
 * 主体ID是全局唯一的雪花ID，不存在跨环境冲突。
 */
export const HMOS_PRINCIPAL_IDS = [
  "1561095811994443776", // uat
  "1453559404485582848", // pro
];

/** 是否鸿蒙智行主体 */
export const isHmosPrincipal = (principalId) =>
  HMOS_PRINCIPAL_IDS.includes(String(principalId ?? ""));
